import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-coupon-slider-2',
  templateUrl: './coupon-slider-2.component.html',
  styleUrls: ['./coupon-slider-2.component.css']
})
export class CouponSlider2Component implements OnInit {
  @Input() coupon: any;
  @Input() typeCode: number;

  @Output() couponSettingsChanged = new EventEmitter<any>();

  changeCouponSettings() {
    this.couponSettingsChanged.emit(this.typeCode);
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-2/coupon-slider-2.component.ts